import en from "../assets/locale/en.json";
import ja from "../assets/locale/ja.json";
import es from "../assets/locale/es.json";
import fr from "../assets/locale/fr.json";
import ru from "../assets/locale/ru.json";
import zh from "../assets/locale/zh.json";

const LOCALES = { en, ja, es, fr, ru, zh };
const DEFAULT_LOCALE = "en";
const LOCALE_STORAGE_KEY = "slLocale";

const isSupported = (value) => Boolean(value && LOCALES[value]);

const normalizeLocale = (raw) => {
  if (!raw) return null;
  const value = String(raw).toLowerCase();
  if (LOCALES[value]) return value;
  const base = value.split(/[-_]/)[0];
  if (LOCALES[base]) return base;
  if (base === "jp") return "ja";
  if (base === "zh" || value.startsWith("zh")) return "zh";
  return null;
};

const readStoredLocale = () => {
  try {
    const stored = window.sessionStorage.getItem(LOCALE_STORAGE_KEY);
    return isSupported(stored) ? stored : null;
  } catch {
    return null;
  }
};

const writeStoredLocale = (locale) => {
  try {
    window.sessionStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    // ignore storage failures
  }
};

const getCurrentLocale = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const fromUrl = normalizeLocale(urlParams.get("locale"));
  if (fromUrl) {
    writeStoredLocale(fromUrl);
    return fromUrl;
  }
  return readStoredLocale() || DEFAULT_LOCALE;
};

const pageLocale = (page) => {
  const locale = getCurrentLocale();
  const bundle = LOCALES[locale] || LOCALES[DEFAULT_LOCALE];
  return bundle[page] ?? LOCALES[DEFAULT_LOCALE][page];
};

export { pageLocale, getCurrentLocale };
